// extracted by mini-css-extract-plugin
export var button = "CtaFooter-module--button--5cf6e";
export var content = "CtaFooter-module--content--7b255";
export var desktopTopSwirl = "CtaFooter-module--desktopTopSwirl--212f7";
export var mobileRootWhiteSpace = "CtaFooter-module--mobileRootWhiteSpace--bca3c";
export var mobileTopSwirl = "CtaFooter-module--mobileTopSwirl--882b4";
export var root = "CtaFooter-module--root--ddb50";
export var rootWhiteSpace = "CtaFooter-module--rootWhiteSpace--f8846";
export var topSwirl = "CtaFooter-module--topSwirl--f12d1";